// extracted by mini-css-extract-plugin
module.exports = {"instructions":"instructions__ZVoJ24tiCetVc","plug":"plug__yq7Q9SAw6+JS8","icon":"icon__bWnMDZaGz9jP4","link":"link__OQomgmj9c+KBi"};